<div v-if="shouldRenderConfig" v-bind:class="getClassName">    
    <div>
        {{$t('PDF DIE-CUT TEMPLATE')}}
    </div>
    <appPreview2D visible="visible"></appPreview2D>
    <appDownloadCF2Button></appDownloadCF2Button>
    <appDownloadPDFButton></appDownloadPDFButton>
</div>

